import { Guid, IApiLink } from "@/types"

export enum AssetTypePurpose {
    rent = "rent",
    rentToBuy = "rentToBuy"
}

export interface ICreateAssetTypeDto {
    productType: number
    description: string
    isLocked: boolean
    purpose?: AssetTypePurpose | null
}

export interface ICreateAssetType {
    dto: ICreateAssetTypeDto
    createLink: IApiLink
}

export interface IGetAssetTypeDto {
    id: Guid
    productType: number
    description: string
    isLocked: boolean
    purpose?: AssetTypePurpose | null
}

export class AssetType {
    id: Guid
    productType: number
    description: string
    isLocked: boolean
    purpose?: AssetTypePurpose | null

    constructor(dto: IGetAssetTypeDto) {
        this.id = dto.id
        this.productType = dto.productType
        this.description = dto.description
        this.isLocked = dto.isLocked
        this.purpose = dto.purpose
    }

    toCreateDto(): ICreateAssetTypeDto {
        return {
            productType: this.productType,
            description: this.description,
            isLocked: this.isLocked,
            purpose: this.purpose
        }
    }
}
